import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlinePhone, HiStar } from 'react-icons/hi';
import Profile1 from '../../Images/ProfileImages/client_profile_1_1773752423248.png';
import Profile2 from '../../Images/ProfileImages/client_profile_2_1773752453585.png';
import Profile3 from '../../Images/ProfileImages/client_profile_3_1773752483889.png';

function CallBack() {
    const navigate = useNavigate();
    
    return (
        <section className="relative overflow-hidden py-24 bg-primary">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-accent/20 rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/10 rounded-full blur-[120px] -translate-x-1/2 translate-y-1/2"></div>
            
            <div className="container-custom relative z-10">
                <div className="max-w-4xl mx-auto text-center space-y-10">
                    <div className="space-y-4">
                        <span className="text-accent font-black uppercase tracking-[0.3em] text-xs">Direct Support</span>
                        <h2 className="text-4xl md:text-6xl font-heading font-black text-white leading-tight">
                            Professional Quality Cleaning <br /> 
                            <span className="italic text-accent/90">With Dedicated Experts</span>
                        </h2>
                        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
                            Our team is dedicated to providing top-notch cleaning services, ensuring every detail is taken care of with precision and care.
                        </p>
                    </div>

                    <div className="flex flex-col md:flex-row items-center justify-center gap-12 py-8 border-y border-white/10">
                        {/* Social Proof */}
                        <div className="flex flex-col items-center gap-4">
                            <div className="flex -space-x-4">
                                {[Profile1, Profile2, Profile3].map((profile, i) => (
                                    <img 
                                        key={i}
                                        src={profile} 
                                        alt="Client" 
                                        className="w-14 h-14 rounded-full border-4 border-primary object-cover shadow-2xl" 
                                    />
                                ))}
                                <div className="w-14 h-14 rounded-full bg-accent text-accent-foreground flex items-center justify-center text-xs font-black border-4 border-primary shadow-2xl">
                                    +5k
                                </div>
                            </div>
                            <div className="flex flex-col items-center">
                                <div className="flex text-accent">
                                    {[1, 2, 3, 4, 5].map(s => <HiStar key={s} size={20} />)}
                                </div>
                                <p className="text-white/60 text-xs font-bold uppercase tracking-widest mt-2">Rated 4.8/5 by our clients</p>
                            </div>
                        </div>

                        <div className="hidden md:block w-px h-16 bg-white/10"></div>

                        {/* CTA Buttons */}
                        <div className="flex flex-col sm:flex-row items-center gap-6">
                            <button 
                                onClick={() => navigate('/contact')}
                                className="bg-white text-primary hover:bg-accent hover:text-accent-foreground px-10 py-5 rounded-2xl font-black uppercase tracking-widest text-xs transition-all duration-300 shadow-2xl hover:-translate-y-1"
                            >
                                Contact Us
                            </button>
                            <a href="tel:+919008425897" className="flex items-center gap-4 text-white hover:text-accent transition-colors group">
                                <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center group-hover:bg-accent group-hover:text-accent-foreground transition-all">
                                    <HiOutlinePhone size={24} />
                                </div>
                                <div className="text-left">
                                    <p className="text-[10px] font-black uppercase tracking-widest text-white/40">Call us anytime</p>
                                    <p className="text-xl font-black">+91 90084 25897</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CallBack;

